"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("./styles.scss");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _targetSectionStrategyDetection = require("./targetSectionStrategyDetection");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'skip-to-content';
exports.cssAnchorName = cssAnchorName;

var SkipToContent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SkipToContent, _Component);

  var _super = _createSuper(SkipToContent);

  function SkipToContent() {
    var _this;

    (0, _classCallCheck2.default)(this, SkipToContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      targetSectionId: _targetSectionStrategyDetection.DEFAULT_TARGET_SECTION_ID
    });
    return _this;
  }

  (0, _createClass2.default)(SkipToContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _targetSection$id;

      var targetSection = (0, _targetSectionStrategyDetection.resolveTargetSection)();
      var targetSectionId = (_targetSection$id = targetSection === null || targetSection === void 0 ? void 0 : targetSection.id) !== null && _targetSection$id !== void 0 ? _targetSection$id : _targetSectionStrategyDetection.DEFAULT_BREADCRUMBS_TARGET_ID;
      this.setState({
        targetSectionId: targetSectionId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return (0, _preact.h)(_phrase.default, {
        p: "accessibility_label.skip_to_main_content",
        renderAsText: true
      }, function (accessibilityLabel) {
        return (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("#".concat(_this2.state.targetSectionId)),
          className: "skip-to-content-btn",
          "aria-label": accessibilityLabel
        }, "Skip to main content");
      });
    }
  }]);
  return SkipToContent;
}(_preact.Component);

exports.default = SkipToContent;